import { Availability, AvailabilitySearch, QcHeader, ScaleBuisinessRuleSection } from "@/types";
import { api } from "@/auth/api";
import { settings } from "@/settings";
import {
    formatDateRecursively,
    getOperator,
    globalConfig,
    headers,
    Masks,
    operator, Paths,
    setOtherFilters,
    UON,
    deepClone
} from "@/utils";
import { saveProductAvailability } from "@/store/services/financing/product";
import { useApi } from "@/requests/useApi";

import store from "@/store";
import { extract } from "@/commons/businessRules";

const buisinessRuleResults = {
    category: '',
    class: '',
    priority: 0,
    advancedConfigurationToggle: false,
}

export const saveAvailability = async (availability: any, daaqResourceUid?: string) => {
    formatDateRecursively(availability.validity, Masks.dateMask_Sys, Masks.dateMask)
    if (availability.availableCategories) {
        (store.state.queryBuilderModule.queryBuilder[ScaleBuisinessRuleSection.AVAILABILITY as any] as any).selectedBuisinessRule!.returnMultipleResults = true
        deleteFromAvailabilityAvailableCategories(availability)
        availability.availableCategories.ruleEngineId = null
        //copie envoyée au back sans le préfixe catégorie dans la classe ('ACTIVITY.VND' -> 'VND').
        availability.availableCategories.rule = stripClassPrefix(deepClone((store.state.queryBuilderModule.queryBuilder[ScaleBuisinessRuleSection.AVAILABILITY as any] as any).selectedBuisinessRule));
        availability.availableCategories = filterKeys(availability.availableCategories, ['rule', 'ruleEngineId']);
    }
    return await saveProductAvailability(availability, daaqResourceUid)
}

function filterKeys(obj: any, allowedKeys:any ) {
    return Object.fromEntries(
      Object.entries(obj).filter(([key]) => allowedKeys.includes(key))
    );
  }

export async function getAvailability(resourceUid: string): Promise<any> {
    const { response } = await useApi(UON.SystemUid.odmProduct, Paths.productAvailability).get(resourceUid)
    const availability = buildAvailabilityRule(response)
    return availability
}
export const buildAvailabilityRule = async (availability: any) => {

    if (availability.availableCategories.rule) {
        //la liste « Classe » a pour valeurs 'CATEGORIE.CODE', on remet le préfixe pour l'affichage.
        addClassPrefix(availability.availableCategories.rule);

        (store.state.queryBuilderModule.queryBuilder[ScaleBuisinessRuleSection.AVAILABILITY as any] as any).selectedBuisinessRule = availability.availableCategories.rule
        
        const extracRule = extract(availability.availableCategories.rule, buisinessRuleResults);
        store.dispatch("queryBuilderModule/setbrResluts", { extracRule: extracRule, currentSection: ScaleBuisinessRuleSection.AVAILABILITY });
        availability.availableCategories = extracRule || {}
    }

    return availability



}
/**
 * Dans la BR d'éligibilité, la classe ne porte que son code ('VND') :
 * la catégorie ('ACTIVITY') est déjà renvoyée par un autre résultat.
 */
const CLASS_HEADER = /^oh-(Output-Header-)?class-businessRuleId$/;
const CATEGORY_HEADER = /^oh-(Output-Header-)?category-businessRuleId$/;
const resultValue = (result: string) => result?.match(/^return\s+'(.*)'$/)?.[1];

/** Enregistrement : return 'ACTIVITY.VND' -> return 'VND'. */
function stripClassPrefix(rule: any) {
    rule?.childBusinessRuleItem?.forEach((item: any) =>
        item.childBusinessRuleResult?.forEach((res: any) => {
            const value = resultValue(res.result);
            if (CLASS_HEADER.test(res.outputHeader?.externalId) && value?.includes('.')) {
                res.result = `return '${value.substring(value.indexOf('.') + 1)}'`;
            }
        }));
    return rule;
}

/** Chargement : return 'VND' -> return 'ACTIVITY.VND' (valeur attendue par la liste « Classe »). */
function addClassPrefix(rule: any) {
    rule?.childBusinessRuleItem?.forEach((item: any) => {
        const categoryResult = item.childBusinessRuleResult?.find((res: any) => CATEGORY_HEADER.test(res.outputHeader?.externalId));
        const category = resultValue(categoryResult?.result);
        item.childBusinessRuleResult?.forEach((res: any) => {
            const value = resultValue(res.result);
            if (CLASS_HEADER.test(res.outputHeader?.externalId) && category && category !== 'null' && value && value !== 'null' && !value.includes('.')) {
                res.result = `return '${category}.${value}'`;
            }
        });
    });
    return rule;
}

export const deleteFromAvailabilityAvailableCategories = async (availability: any) => {
    delete availability.availableCategories.advancedConfigurationToggle
    delete availability.availableCategories.category
    delete availability.availableCategories.class
    delete availability.availableCategories.priority

}


export const availabilityFilter = async (filter: AvailabilitySearch, offset?:any , limit?: any) => {

    const qc_header: QcHeader = {
        qc: {
            queryId: 'product-availability-filter-search',
            offset: offset || 0,
            limit: limit || 100,
            parameters: {
                ...filter
            }
        }
    };

    const operators = [];
    const PRODUCT_AVAILABILITY = "product_product_availability";

    if (filter?.name) {
        operators.push(
            operator(
                { val: filter.name, table: PRODUCT_AVAILABILITY, dbField: "application_name" }
            ).LIKE
        );
    }

    if (filter?.validity?.from && filter?.validity?.from !== '') {
        operators.push(
            operator(
                { val: filter.validity.from, table: PRODUCT_AVAILABILITY, dbField: "validity_from" }
            ).GREATER_THAN_EQUAL
        );
    }

    if (filter?.validity?.until && filter?.validity?.until !== '') {
        operators.push(
            operator(
                { val: filter.validity.until, table: PRODUCT_AVAILABILITY, dbField: "validity_until" }
            ).LESS_THAN_EQUAL
        );
    }

    if (filter?.context) {
        operators.push(
            operator(
                { val: filter.context, table: PRODUCT_AVAILABILITY, dbField: "_context" }
            ).LIKE
        );
    }

    if (!filter?.context) {
         operators.push(getOperator(PRODUCT_AVAILABILITY, "_context", "EQUAL", "'DISTRIBUTION'", "_context"))
     }

    setOtherFilters(operators, qc_header);

    return await api().get(settings.api_query_url, {
        headers: headers({
            qc: JSON.stringify(qc_header.qc)
        })
    });
}

export const availabilityKeys: string[] = [
    'category',
    'class',
    'priority'
]

export const outputFormAdvanceConfiguration: any = {
    category: ["category"],
    class: ["class"],
    priority: ["priority"]
}
